export default __webpack_public_path__ + "static/media/arrow-split-white.c4b08686.svg";